import { render } from "./WalletExchangeTransfersList.vue?vue&type=template&id=c4181cea&scoped=true"
import script from "./WalletExchangeTransfersList.vue?vue&type=script&lang=js"
export * from "./WalletExchangeTransfersList.vue?vue&type=script&lang=js"

import "./WalletExchangeTransfersList.vue?vue&type=style&index=0&id=c4181cea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4181cea"]])

export default __exports__